import { IListItem } from './ilist-item';
import { IGeneric } from './igeneric';

export type GenericLoadScope = 'all' | 'person';

export interface IGenericState {
  selectedGeneric: IListItem<IGeneric>;
  allGenerics: IListItem<IGeneric>[];
  Id: number;
  genericAno: number;
  identification: IListItem<IGeneric>;
  tno?: number;
  genericLabel?: string;
  loadScope?: GenericLoadScope;
  /** Indica que a ocorrência foi aberta a partir de um clique no generic-list padrão, habilitando o botão Duplicar. */
  openedFromGenericList?: boolean;
}
